//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Paginate from 'vuejs-paginate';
import StatusPassos from '../../../../../../shared-components/workflow/StatusPassos';
import { getMoney } from '../../../../../../common/functions/helpers';
import informacoesContratoMixin from './informacoesContratoMixin';

export default {
  name: 'ApuracaoFinalizadaTabela',
  mixins: [informacoesContratoMixin],
  components: {
    Paginate,
    StatusPassos,
  },
  props: {
    carregando: Boolean,
    negociacoes: Array,
    paginas: Number,
  },
  data() {
    return {
      workflowAcordo: this.$api.workflowAcordo(this.$resource),

      statusPassos: {},
      linhaSelecionada: {},
      justificativaAvaliacao: '',

      indexPagina: 0,
      cabecalho: [
        this.$tc('label.acoes', 1),
        this.$t('label.numero_acordo'),
        this.$tc('label.cliente', 1),
        this.$t('label.acordo'),
        this.$t('label.tipo_acordo'),
        this.$tc('label.inicio_vigencia', 1),
        this.$tc('label.fim_vigencia', 1),
        this.$tc('label.representante', 1),
        this.$t('label.status'),
      ],
      esperarRequest: false,
    };
  },
  methods: {
    getMoney,
    cancelarEnvioParaAnalise() {
      this.$refs.modalAnalise.close();
    },
    iniciarEnvioParaAnalise(row) {
      this.linhaSelecionada = row;
      this.justificativaAvaliacao = '';
      this.$refs.modalAnalise.open();
    },
    enviarParaAnalise() {
      const idAcordo = this.linhaSelecionada.numeroAcordo;
      this.workflowAcordo.enviarAnalise(
        { idAcordo },
        { observacao: this.justificativaAvaliacao })
        .then(() => {
          this.$refs.modalAnalise.close();
          this.refazConsulta();
        })
        .catch((err) => {
          this.$toast.create(this.$t(err), 'snack', 3E3);
        });
    },
    cancelarReprovacao() {
      this.$refs.modalReprovacao.close();
    },
    iniciarReprovacao(row) {
      this.linhaSelecionada = row;
      this.justificativaAvaliacao = '';
      this.$refs.modalReprovacao.open();
    },
    reprovar() {
      if (this.esperarRequest) return;
      this.esperarRequest = true;

      const idAcordo = this.linhaSelecionada.numeroAcordo;
      this.workflowAcordo.reprovar(
        { idAcordo },
        { observacao: this.justificativaAvaliacao })
        .then(() => {
          this.esperarRequest = false;
          this.$refs.modalReprovacao.close();
          this.refazConsulta();
        })
        .catch((err) => {
          this.esperarRequest = false;
          this.$toast.create(this.$t(err), 'snack', 3E3);
        });
    },
    cancelarAprovacao() {
      this.$refs.modalAprovacao.close();
    },
    iniciarAprovacao(row) {
      this.linhaSelecionada = row;
      this.justificativaAvaliacao = '';
      this.$refs.modalAprovacao.open();
    },
    aprovar() {
      if (this.esperarRequest) return;
      this.esperarRequest = true;

      const idAcordo = this.linhaSelecionada.numeroAcordo;
      this.workflowAcordo.aprovar(
        { idAcordo },
        { observacao: this.justificativaAvaliacao })
        .then(() => {
          this.esperarRequest = false;
          this.$refs.modalAprovacao.close();
          this.refazConsulta();
        })
        .catch((err) => {
          this.esperarRequest = false;
          this.$toast.create(this.$t(err), 'snack', 3E3);
        });
    },
    exibirAcompanhamento(row) {
      const idAcordo = row.numeroAcordo;
      this.workflowAcordo.statusPasso({ idAcordo }, { idAcordo })
        .then((res) => {
          this.statusPassos = res.data;
          this.$refs.modalAcompanhamento.open();
        })
        .catch((err) => {
          this.$toast.create(this.$t(err), 'snack', 3E3);
        });
    },
    classeCabecalho(index) {
      switch (index) {
        case 2: // cliente
          return 'Tabela__LargeColumn';
        case 3: // acordo
        case 7: // representante
        case 8: // status
          return 'Tabela__BigColumn';
        case 4: // tipo acordo
          return 'Tabela__MediumColumn';
        default:
          return '';
      }
    },
    styleCard() {
      const style = {};
      if (!this.possuiRegistros() || this.paginas === 1) {
        style['padding-bottom'] = '16px';
      }
      return style;
    },
    possuiRegistros() {
      return this.negociacoes.length !== 0;
    },
    clickHandler(pagina) {
      this.indexPagina = pagina - 1;
      this.$emit('NEGOCIACAO_AG_APROVACAO_TABELA_PAGINA', pagina);
    },
    refazConsulta() {
      const paginaInicial = 0;
      this.$emit('NEGOCIACAO_AG_APROVACAO_TABELA_PAGINA', paginaInicial);
    },
    refazPaginacao() {
      this.indexPagina = 0;
    },
    statusApuracao(status) {
      return this.$tc(`status_entidade.${status.toLowerCase()}`, 1);
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/acompanhamento/NegociacoesAguardandoAprovacao.vue?vue&type=script&lang=js&